import { Tokens } from '@zapier/design-tokens';
const BaseColors = {
    zapier: Tokens.color.brand.orange.value,
    earth: Tokens.color.brand.earth.value,
    moss: Tokens.color.brand.moss.value,
    night: Tokens.color.brand.night.value,
    lavender: Tokens.color.brand.lavender.value,
    peach: Tokens.color.brand.peach.value,
    bolt: Tokens.color.brand.bolt.value,
    sky: Tokens.color.brand.sky.value,
    cream: Tokens.color.brand.cream.value,
    blue: Tokens.color.ui.action.blue600.value,
    blue80: Tokens.color.ui.action.blue500.value,
    blue60: Tokens.color.ui.action.blue400.value,
    blue40: Tokens.color.ui.action.blue300.value,
    blue20: Tokens.color.ui.action.blue200.value,
    blue10: Tokens.color.ui.action.blue100.value,
    blue600: Tokens.color.ui.action.blue600.value,
    blue500: Tokens.color.ui.action.blue500.value,
    blue400: Tokens.color.ui.action.blue400.value,
    blue300: Tokens.color.ui.action.blue300.value,
    blue200: Tokens.color.ui.action.blue200.value,
    blue100: Tokens.color.ui.action.blue100.value,
    error: '#e02d00',
    error10: '#ffe1d5',
    error120: '#b92602',
    error500: Tokens.color.ui.feedback.error500.value,
    error400: Tokens.color.ui.feedback.error400.value,
    error300: Tokens.color.ui.feedback.error300.value,
    error200: Tokens.color.ui.feedback.error200.value,
    error100: Tokens.color.ui.feedback.error100.value,
    warning: '#ffc43e',
    warning10: '#ffe7b2',
    warning500: Tokens.color.ui.feedback.warning500.value,
    warning400: Tokens.color.ui.feedback.warning400.value,
    warning300: Tokens.color.ui.feedback.warning300.value,
    warning200: Tokens.color.ui.feedback.warning200.value,
    warning100: Tokens.color.ui.feedback.warning100.value,
    success: '#62d493',
    success10: '#daf5e6',
    success500: Tokens.color.ui.feedback.success500.value,
    success400: Tokens.color.ui.feedback.success400.value,
    success300: Tokens.color.ui.feedback.success300.value,
    success200: Tokens.color.ui.feedback.success200.value,
    success100: Tokens.color.ui.feedback.success100.value,
    neutral800: Tokens.color.neutrals.neutral800.value,
    neutral700: Tokens.color.neutrals.neutral700.value,
    neutral600: Tokens.color.neutrals.neutral600.value,
    neutral500: Tokens.color.neutrals.neutral500.value,
    neutral400: Tokens.color.neutrals.neutral400.value,
    neutral300: Tokens.color.neutrals.neutral300.value,
    neutral200: Tokens.color.neutrals.neutral200.value,
    neutral100: Tokens.color.neutrals.neutral100.value,
    neutral100rgb: '255, 253, 249',
    black: '#000000',
    white: '#ffffff',
    transparent: 'transparent',
    inherit: 'inherit',
    currentColor: 'currentColor',
    pink: Tokens.color.ui.accent.pink.value,
    purple: Tokens.color.ui.accent.purple.value,
    lava: '#ff4a00',
    lava120: '#d93f00',
    lava80: '#ff6e33',
    lava60: '#ff9266',
    lava40: '#ffb799',
    lava20: '#ffdbcc',
    lava10: '#ffede6',
    lava5: '#fff6f2',
    ocean: '#136bf5',
    ocean120: '#2655bd',
    ocean80: '#4289f7',
    ocean60: '#71a6f9',
    ocean40: '#a1c4fb',
    ocean20: '#d0e1fd',
    ocean10: '#e7f0fe',
    ocean5: '#f3f8ff',
    sun: '#ffc43e',
    sun120: '#e6b038',
    sun80: '#ffd065',
    sun60: '#ffdc8b',
    sun40: '#ffe7b2',
    sun20: '#fff3d8',
    sun10: '#fff9ec',
    sun5: '#fffcf5',
    gray: '#333333',
    gray80: '#424242',
    gray60: '#757575',
    gray40: '#cccccc',
    gray20: '#e6e6e6',
    gray10: '#f2f2f2',
    gray5: '#fafafa',
};
const ColorAliases = {
    brand: BaseColors.lava,
    blueJeans: BaseColors.blue600,
    bluebell: BaseColors.blue500,
    periwinkle: BaseColors.blue400,
    lilac: BaseColors.blue300,
    hydrangea: BaseColors.blue200,
    acidWash: BaseColors.blue100,
};
export const Colors = Object.assign(Object.assign({}, BaseColors), ColorAliases);
//# sourceMappingURL=Colors.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
